// Import all slides
import Slide1Title from '@/components/slides/Slide1Title';
import Slide2Problem from '@/components/slides/Slide2Problem';
import Slide3Solution from '@/components/slides/Slide3Solution';
import Slide4Differentiation from '@/components/slides/Slide4Differentiation';
import Slide5Audience from '@/components/slides/Slide5Audience';
import Slide6BusinessModel from '@/components/slides/Slide6BusinessModel';
import Slide7GTM from '@/components/slides/Slide7GTM';
import Slide8Competition from '@/components/slides/Slide8Competition';
import SlideGTMStrategy from '@/components/slides/SlideGTMStrategy';
import Slide9Roadmap from '@/components/slides/Slide9Roadmap';
import Slide10Ask from '@/components/slides/Slide10Ask';
import Slide11UnitEconomics from '@/components/slides/Slide11UnitEconomics';
import Slide12Compliance from '@/components/slides/Slide12Compliance';
import Slide13Roadmap from '@/components/slides/Slide13Roadmap';
import Slide14Team from '@/components/slides/Slide14Team';
import Slide15Ask from '@/components/slides/Slide15Ask';

export const slides = [
  { id: 1, component: Slide1Title, title: 'Cover' },
  { id: 2, component: Slide2Problem, title: 'The Problem' },
  { id: 3, component: Slide3Solution, title: 'The Gap' },
  { id: 4, component: Slide4Differentiation, title: 'The Solution' },
  { id: 5, component: Slide5Audience, title: 'Evolution' },
  { id: 6, component: Slide6BusinessModel, title: 'Target Users' },
  { id: 7, component: Slide7GTM, title: 'Business Model' },
  { id: 8, component: Slide8Competition, title: 'Growth Strategy' },
  { id: 9, component: SlideGTMStrategy, title: 'GTM Strategy' },
  { id: 10, component: Slide9Roadmap, title: 'Competition' },
  { id: 11, component: Slide10Ask, title: 'AI Architecture' },
  { id: 12, component: Slide11UnitEconomics, title: 'Unit Economics' },
  { id: 13, component: Slide12Compliance, title: 'Compliance' },
  { id: 14, component: Slide13Roadmap, title: 'Roadmap' },
  { id: 15, component: Slide14Team, title: 'Team' },
  { id: 16, component: Slide15Ask, title: 'The Ask' },
];